import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { MarketplacesService } from 'src/app/core/services/marketplaces.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { ICountry } from 'src/app/core/models/country.interface';
import { ConstantService } from 'src/app/core/services/constant.service';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SaleOrderFromXlsxService } from 'src/app/core/services/so-from-xlsx.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { RegistrationService } from 'src/app/modules/customer-registration/services/registration.service';
import { SaleOrderService } from '../../services/sale-order.service';
import { PageParams } from 'src/app/core/models/page-params.model';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SyncOptionsPopupComponent } from './sync-options-popup/sync-options-popup.component';
import { ChangeDetectorRef } from '@angular/core';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { ShipmentConsolStatus } from 'src/app/shared/enums/shipment-consol-status.enum';


@Component({
    selector: 'eci-so-from-xlsx',
    templateUrl: './so-from-xlsx.component.html',
    styleUrls: ['./so-from-xlsx.component.scss']
})
export class SaleOrderFromXlsxComponent implements OnInit {

    header: string = 'XLSX for Sale Orders';

    sub$: Subscription = new Subscription();
    listOfMarketplaces: any;
    listOfMarketplacesWithTemplates: any;
    listOfMarketplacesWithoutTemplates: any;
    showLoader: boolean = false;
    fromDate: FormControl = new FormControl();
    toDate: FormControl = new FormControl();

    listOfTemplates: any[] = [];
    listOfSelectedItems: any[] = [];

    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    companyList: any[];

    fileMode: FormControl = new FormControl('');

    shopIdByfilter: FormControl = new FormControl('');
    partnerNameByfilter: FormControl = new FormControl('');

    fileNameFilter: FormControl = new FormControl('');
    fileNameSearchId: FormControl = new FormControl('');
    fileNameList = [];
    previousPageFileNames: number = 0;
    totalPagesFileNames: number = 1;
    isLoadingFileNames: boolean = false;
    private fileNameRequestId = 0;

    searchShopIdDropDown = new FormControl('');
    searchLocateShopDropDown = new FormControl('');
    searchPartnerNameDropDown = new FormControl('');
    searchFileTypeDropDown = new FormControl('');

    listOfShops: any = [];
    previousPageShops: number = 0;
    totalPagesShops: number = 1;
    isLoadingShops: boolean = false;
    private shopRequestId = 0;

    listOfShopsForLocate: any[] = [];
    previousPageLocateShops: number = 0;
    totalPagesLocateShops: number = 1;
    isLoadingLocateShops: boolean = false;
    private locateShopRequestId = 0;
    private locateCompanyId: number = null;
    private isLocateShopDropdownOpen = false;
    partnerList = [];
    partnerListForLocate: any[] = [];
    pageParams: PageParams = new PageParams();

    isProcessed: boolean = false;

    createConsoleShipment: FormControl = new FormControl(false);
    countryOfOrigin: FormControl = new FormControl('');
    countryOfDestination: FormControl = new FormControl('');
    consoleShipmentId: FormControl = new FormControl('');
    originSearchCountry: FormControl = new FormControl('');
    destinationSearchCountry: FormControl = new FormControl('');
    consoleShipmentSearch: FormControl = new FormControl('');
    availableOriginCountries: ICountry[] = [];
    availableDestinationCountries: ICountry[] = [];
    fullCountriesList: ICountry[] = [];
    consoleShipmentList: any[] = [];

    private readonly consoleShipmentAcceptingStatuses = [
        ShipmentConsolStatus.DRAFT,
        ShipmentConsolStatus.NEW,
        ShipmentConsolStatus.PENDING,
    ];

    dataSource: any;
    displayedColumns = [
        'checkboxes',
        'dateTime',
        'errors',
        'fileMode',
        'templateUsed',
        'uploadStatus',
        'fileName',
        'customerName',
        'marketplaceName',
        'partnerId',
        'shopId',
        'actions',
        'report',
    ];

    @ViewChild('companySelect', { static: true }) companySelect: MatSelect;
    @ViewChild('shopSelect', { static: true }) shopSelect: MatSelect;
    @ViewChild('table', { static: true, read: ElementRef }) table: ElementRef;

    get isAllSelected(): boolean {
        const rows = this.getTableRows();
        return this.listOfSelectedItems?.length > 0 &&
            this.listOfSelectedItems?.length === rows.length;
    }

    get hasSelectedItems(): boolean {
        return this.listOfSelectedItems?.length > 0;
    }

    get isConsoleShipmentFormInvalid(): boolean {
        if (!this.createConsoleShipment.value) {
            return false;
        }

        const hasCooAndCod = !!this.countryOfOrigin.value && !!this.countryOfDestination.value;
        const hasConsoleShipment = !!this.consoleShipmentId.value;

        return !hasCooAndCod && !hasConsoleShipment;
    }

    get isUploadDisabled(): boolean {
        return !this.hasSelectedItems || this.isProcessed || this.isConsoleShipmentFormInvalid;
    }

    constructor(
        public localStorageSvc: LocalStorageService,
        public userSvc: UserService,
        private marketplaceSvc: MarketplacesService,
        private router: Router,
        private route: ActivatedRoute,
        private xlsxSOFilesSvc: SaleOrderFromXlsxService,
        private regSvc: RegistrationService,
        private saleOrderSvc: SaleOrderService,
        private notify: NotificationService,
        private datePipe: DatePipe,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private constSvc: ConstantService,
        private consolShipmentSvc: ConsolidateShipmentService,

    ) {
    }

    ngOnInit() {
        this.sub$.add(
            this.marketplaceSvc.availableMarketplaces$.subscribe(res => {
                this.listOfMarketplaces = res;
            })
        );

        this.getXlsxList();

        this.getListCompanies();
        this.getAllShopsData();
        this.getListOfFileName();
        this.getListOfCountries();

        this.fileNameSearchId.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousPageFileNames = 0;
            this.getListOfFileName(1, 20, value || '');
        });

        this.searchShopIdDropDown.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousPageShops = 0;
            this.getAllShopsData(1, 20, value || '');
        });

        this.searchLocateShopDropDown.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            if (!this.isLocateShopDropdownOpen) {
                return;
            }
            this.previousPageLocateShops = 0;
            this.getLocateShopsData(1, 20, value || '', this.locateCompanyId);
        });

        this.createConsoleShipment.valueChanges.subscribe((checked) => {
            if (!checked) {
                this.countryOfOrigin.reset();
                this.countryOfDestination.reset();
                this.consoleShipmentId.reset();
                this.consoleShipmentSearch.reset();
            } else {
                this.loadConsoleShipments();
            }
        });
        // this.searchCustomerName.valueChanges.pipe(debounceTime(500)).subscribe(value => {
        //     this.getListCompanies();
        // });
    }

    getListOfFileName(
        page: number = this.previousPageFileNames + 1,
        limit: number = 20,
        q: string = this.fileNameSearchId.value
    ): void {
        if (page > 1 && (this.isLoadingFileNames || this.previousPageFileNames >= this.totalPagesFileNames)) {
            return;
        }
        const requestId = ++this.fileNameRequestId;
        this.isLoadingFileNames = true;
        this.saleOrderSvc.getfileName(page, limit, q || '').subscribe(
            (result) => {
                if (requestId !== this.fileNameRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(
                        this.fileNameList.map((file) => file.xlsx_sale_order_files_id)
                    );
                    this.fileNameList = [
                        ...this.fileNameList,
                        ...items.filter(
                            (file) => !existingIds.has(file.xlsx_sale_order_files_id)
                        ),
                    ];
                } else {
                    this.fileNameList = this.keepSelectedFiles(items);
                }
                this.previousPageFileNames = meta?.currentPage || page;
                this.totalPagesFileNames = meta?.totalPages || 1;
                this.isLoadingFileNames = false;
            },
            () => {
                if (requestId === this.fileNameRequestId) {
                    this.isLoadingFileNames = false;
                }
            }
        );
    }

    onFileNameDropdownOpened(): void {
        this.previousPageFileNames = 0;
        this.getListOfFileName(1, 20, this.fileNameSearchId.value || '');
    }

    private keepSelectedFiles(files: any[] = []): any[] {
        const selectedIds = this.fileNameFilter?.value;
        if (!selectedIds || (Array.isArray(selectedIds) && selectedIds.length === 0)) {
            return files;
        }
        const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
        const selected = this.fileNameList.filter(
            (file) =>
                ids.some((id) => id == file.xlsx_sale_order_files_id) &&
                !files.some((item) => item.xlsx_sale_order_files_id == file.xlsx_sale_order_files_id)
        );
        return selected.length ? [...files, ...selected] : files;
    }

    getXlsxList(
        page: number = this.pageParams.pageIndex + 1,
        limit: number = this.pageParams.pageSize
    ): void {
        const dateTo = this.toDate.value
            ? this.datePipe.transform(this.toDate.value, 'yyyy-MM-dd')
            : '';
        const dateFrom = this.fromDate.value
            ? this.datePipe.transform(this.fromDate.value, 'yyyy-MM-dd')
            : '';

        this.xlsxSOFilesSvc.getAllSOXlsx(
            page,
            limit,
            dateFrom,
            dateTo,
            this.customerName.value,
            this.shopIdByfilter.value,
            this.fileNameFilter.value,
            this.fileMode.value
        ).subscribe(res => {
            const items = Array.isArray(res) ? res : res?.items || [];
            this.listOfTemplates = items;
            this.dataSource = items;
            if (res?.meta) {
                this.pageParams.pageSize = res.meta.itemsPerPage;
                this.pageParams.pageIndex = res.meta.currentPage - 1;
                this.pageParams.length = res.meta.totalItems;
            }
        });
    }

    search(): void {
        this.pageParams.pageIndex = 0;
        this.getXlsxList(1, this.pageParams.pageSize);
    }

    delete(id: number): void {
        this.xlsxSOFilesSvc.delete(id).subscribe(res => {
        });
    }

    navigateTo(id: number): void {
        this.router.navigate([`details/${id}`], { relativeTo: this.route });
    }

    view(id: number): void {
        this.xlsxSOFilesSvc.getOne(Number(id)).subscribe(res => {
            const a = document.createElement('a')
            a.href = res.file;
            a.click();
        });
    }

    viewReport(id: number): void {
        this.xlsxSOFilesSvc.downloadReport(Number(id)).subscribe(res => {
            const a = document.createElement('a')
            a.href = res.file;
            a.click();
        });
    }

    isChecked(id: number): boolean {
        return !!this.listOfSelectedItems.find(el => el.id === id);
    }

    public isReport(element: any): boolean {
        return element.uploadMethod === 'API Web Report';
    }

    selectionChanged(event: MatCheckboxChange, item): void {
        // console.log('Checkbox change event:', event);
        // console.log('Selected item:', item)
        if (event.checked) {
            if (!this.isChecked(item.id)) {
                // console.log('Adding item to selected items:', item);
                this.listOfSelectedItems.push(item);
            }
        } else {
            if (this.isChecked(item.id)) {
                // console.log('Removing item from selected items:', item);
                this.listOfSelectedItems.splice(this.listOfSelectedItems.findIndex(el => el.id === item.id), 1);
            }
        }
        this.resetConsoleShipmentOptionsIfNeeded();
    }

    selectAllChanged(event: MatCheckboxChange): void {
        if (event.checked) {
            this.listOfSelectedItems = this.getTableRows().filter(el => !!el.shopName);
        } else {
            this.listOfSelectedItems = [];
        }
        this.resetConsoleShipmentOptionsIfNeeded();
    }

    private getTableRows(): any[] {
        if (Array.isArray(this.dataSource)) {
            return this.dataSource;
        }
        return this.dataSource?.data || [];
    }

    private resetConsoleShipmentOptionsIfNeeded(): void {
        if (!this.hasSelectedItems) {
            this.createConsoleShipment.setValue(false);
            this.countryOfOrigin.reset();
            this.countryOfDestination.reset();
            this.consoleShipmentId.reset();
            this.consoleShipmentSearch.reset();
        }
    }

    private loadConsoleShipments(): void {
        this.consolShipmentSvc.getConsoleShipmentsForXlsx().subscribe(
            data => {
                this.consoleShipmentList = data || [];
            },
            () => {
                this.notify.showError('Failed to load console shipments.');
            }
        );
    }

    private validateConsoleShipmentBeforeUpload(): boolean {
        if (!this.createConsoleShipment.value || !this.consoleShipmentId.value) {
            return true;
        }

        const selectedShipment = this.consoleShipmentList.find(
            shipment => Number(shipment.id) === Number(this.consoleShipmentId.value)
        );

        if (!selectedShipment) {
            this.notify.showError('Selected console shipment could not be found.');
            return false;
        }

        if (!this.consoleShipmentAcceptingStatuses.includes(Number(selectedShipment.status))) {
            this.notify.showError(
                'Selected console shipment cannot accept sale orders. Only Draft, New, or Pending shipments are allowed.'
            );
            return false;
        }

        return true;
    }

    getListOfCountries(): void {
        this.constSvc.getAvailableCountriesForScroll(1, 1000, false, '').subscribe(data => {
            if (!data) {
                return;
            }
            this.fullCountriesList = data.items;
            this.availableOriginCountries = data.items;
            this.availableDestinationCountries = data.items;
        });
    }

    public sync(withReport: boolean = false): void {
        if (!this.validateConsoleShipmentBeforeUpload()) {
            return;
        }
        // const dialogRef = this.dialog.open(SyncOptionsPopupComponent);
        // dialogRef.afterClosed().subscribe(value => {
        //     if (value === undefined) {
        //         return;
        //     } else {
        //         const items = this.listOfSelectedItems.map((el) => Number(el.id));
        //         this.xlsxSOFilesSvc.sync({ ids: items, withReport, templateType: value }).subscribe((res) => {
        //             this.listOfSelectedItems = [];
        //             this.notify.showSuccessMessage('Synchronization started successfully');
        //             // this.notify.showWarn('Errors you could find on the Developers => Sale Order Errors tab');
        //         });
        //     }
        // });

        //const items = this.listOfSelectedItems.map((el) => Number(el.id));
        this.isProcessed = true;
        const items = this.listOfSelectedItems.map((el) => ({
            id: Number(el.id),
            tempShopName: el.tempShopName, // Extract tempShopName
            templateUsed: el.templateUsed, // Extract templateUsed (custom / default)
            fileMode: el.fileMode // Extract fileMode (Regular / Batch)
        }));
        this.xlsxSOFilesSvc.sync(this.buildSyncPayload(items, withReport)).subscribe((res) => {
            this.resetAfterUpload();
        }, err => this.isProcessed = false);
    }

    public uploadXlsxSoToDB(withReport: boolean = false): void {
        if (!this.validateConsoleShipmentBeforeUpload()) {
            return;
        }

        this.isProcessed = true;
        const items = this.listOfSelectedItems.map((el) => ({
            id: Number(el.id),
            tempShopName: el.tempShopName, // Extract tempShopName
            templateUsed: el.templateUsed, // Extract templateUsed (custom / default)
            fileMode: el.fileMode // Extract fileMode (Regular / Batch)
        }));

        this.xlsxSOFilesSvc.sync(this.buildSyncPayload(items, withReport)).subscribe((res) => {
            this.resetAfterUpload();
        }, err => this.isProcessed = false);
    }

    private buildSyncPayload(items: any[], withReport: boolean): any {
        const payload: any = { items, withReport };

        if (this.createConsoleShipment.value) {
            payload.createConsoleShipment = true;

            if (this.consoleShipmentId.value) {
                payload.consoleShipmentId = Number(this.consoleShipmentId.value);
            }
            if (this.countryOfOrigin.value) {
                payload.countryOfOrigin = this.countryOfOrigin.value;
            }
            if (this.countryOfDestination.value) {
                payload.countryOfDestination = this.countryOfDestination.value;
            }
        }

        return payload;
    }

    private resetAfterUpload(): void {
        const withConsoleShipment = this.createConsoleShipment.value;
        const updatingExistingConsoleShipment = withConsoleShipment && !!this.consoleShipmentId.value;
        this.listOfSelectedItems = [];
        this.createConsoleShipment.setValue(false);
        this.countryOfOrigin.reset();
        this.countryOfDestination.reset();
        this.consoleShipmentId.reset();
        this.consoleShipmentSearch.reset();
        this.notify.showSuccessMessage(
            updatingExistingConsoleShipment
                ? 'Synchronization and console shipment update started successfully'
                : withConsoleShipment
                    ? 'Synchronization and console shipment creation started successfully'
                    : 'Synchronization started successfully'
        );
        this.getXlsxList();
        this.isProcessed = false;
    }

    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.customerName.value ? this.customerName.value : q;
        this.regSvc.getCompanyListForSales(q).subscribe(data => {
            if (!data) {
                return;
            }
            this.companyList = data;
        });
    }

    getAllShopsData(
        page: number = this.previousPageShops + 1,
        limit: number = 20,
        q: string = this.searchShopIdDropDown.value
    ): void {
        if (page > 1 && (this.isLoadingShops || this.previousPageShops >= this.totalPagesShops)) {
            return;
        }
        const requestId = ++this.shopRequestId;
        this.isLoadingShops = true;
        this.saleOrderSvc.getAllShops(q || '', page, limit).subscribe(
            (result) => {
                if (requestId !== this.shopRequestId) {
                    return;
                }
                const items = result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(this.listOfShops.map((shop) => shop.id));
                    this.listOfShops = [
                        ...this.listOfShops,
                        ...items.filter((shop) => !existingIds.has(shop.id)),
                    ];
                } else {
                    this.listOfShops = this.keepSelectedShops(items);
                }
                this.previousPageShops = meta?.currentPage || page;
                this.totalPagesShops = meta?.totalPages || 1;
                this.isLoadingShops = false;
            },
            () => {
                if (requestId === this.shopRequestId) {
                    this.isLoadingShops = false;
                }
            }
        );
    }

    onShopDropdownOpened(): void {
        this.previousPageShops = 0;
        this.getAllShopsData(1, 20, this.searchShopIdDropDown.value || '');
    }

    private keepSelectedShops(shops: any[] = []): any[] {
        const selectedIds = this.shopIdByfilter?.value;
        if (!selectedIds || (Array.isArray(selectedIds) && selectedIds.length === 0)) {
            return shops;
        }
        const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
        const selected = this.listOfShops.filter(
            (shop) =>
                ids.some((id) => id == shop.id) &&
                !shops.some((item) => item.id == shop.id)
        );
        return selected.length ? [...shops, ...selected] : shops;
    }

    trackByShopId(index: number, shop: any): number | string {
        return shop?.id ?? shop?.shopId ?? index;
    }

    trackByFileId(index: number, file: any): number | string {
        return file?.xlsx_sale_order_files_id ?? index;
    }

    getLocateShopsData(
        page: number = this.previousPageLocateShops + 1,
        limit: number = 20,
        q: string = this.searchLocateShopDropDown.value,
        companyId: number = this.locateCompanyId
    ): void {
        if (page > 1 && (this.isLoadingLocateShops || this.previousPageLocateShops >= this.totalPagesLocateShops)) {
            return;
        }
        const requestId = ++this.locateShopRequestId;
        this.isLoadingLocateShops = true;
        this.saleOrderSvc.getAllShops(q || '', page, limit, companyId).subscribe(
            (result) => {
                if (requestId !== this.locateShopRequestId) {
                    return;
                }
                const items = result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(this.listOfShopsForLocate.map((shop) => shop.id));
                    this.listOfShopsForLocate = [
                        ...this.listOfShopsForLocate,
                        ...items.filter((shop) => !existingIds.has(shop.id)),
                    ];
                } else {
                    this.listOfShopsForLocate = this.keepSelectedLocateShops(items);
                }
                this.previousPageLocateShops = meta?.currentPage || page;
                this.totalPagesLocateShops = meta?.totalPages || 1;
                this.isLoadingLocateShops = false;
            },
            () => {
                if (requestId === this.locateShopRequestId) {
                    this.isLoadingLocateShops = false;
                }
            }
        );
    }

    onLocateShopDropdownOpened(companyId?: number): void {
        this.isLocateShopDropdownOpen = true;
        this.locateCompanyId = companyId || null;
        this.previousPageLocateShops = 0;
        this.getLocateShopsData(1, 20, this.searchLocateShopDropDown.value || '', this.locateCompanyId);
    }

    onLocateShopDropdownClosed(): void {
        this.isLocateShopDropdownOpen = false;
        this.searchLocateShopDropDown.setValue('', { emitEvent: false });
    }

    private keepSelectedLocateShops(shops: any[] = []): any[] {
        const rows = this.getTableRows();
        const selectedShops = [];
        rows.forEach((row) => {
            const selectedId = row.tempShopName;
            if (selectedId === undefined || selectedId === null || selectedId === '') {
                return;
            }
            const alreadyInPage = shops.some((item) => item.id == selectedId)
                || selectedShops.some((item) => item.id == selectedId);
            if (alreadyInPage) {
                return;
            }
            const fromList = this.listOfShopsForLocate.find((shop) => shop.id == selectedId);
            const fromRow = row.tempShop;
            if (fromList) {
                selectedShops.push(fromList);
            } else if (fromRow && fromRow.id == selectedId) {
                selectedShops.push(fromRow);
            }
        });
        return selectedShops.length ? [...shops, ...selectedShops] : shops;
    }

    compareLocateShopIds = (a: any, b: any): boolean => a == b;

    //fetch list of all partners
    // getPartnersList(): void {
    //     this.partnerService.getPartnersList().subscribe(result => {
    //             this.partnerList = result;
    //     });
    //   }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.getXlsxList(e.pageIndex + 1, e.pageSize);
        this.table?.nativeElement?.scrollIntoView();
    }

    locateShopToXlsx(xlsxElement: any, change: MatSelectChange): void {
        if (change.value === undefined || change.value === null || change.value === '') {
            return;
        }
        xlsxElement.tempShopName = change.value;
        xlsxElement.tempShop = this.listOfShopsForLocate.find((shop) => shop.id == change.value) || xlsxElement.tempShop;
    }

    saveShopForXlsx(xlsxElement: any): void {
        if (!xlsxElement.tempShopName) {
            return; // No shop selected to save
        }

        // Save the shop to the backend
        this.xlsxSOFilesSvc.locateShopId(xlsxElement.id, {
            shopId: xlsxElement.tempShopName, // Use tempShopName for saving
        }).subscribe(res => {
            // Update shopName and clear tempShopName
            xlsxElement.shopName = xlsxElement.tempShopName;
            xlsxElement.tempShopName = null; // Clear temporary selection
            // console.log('Shop saved successfully:', xlsxElement.shopName);

            // Optionally refresh the data
            this.getXlsxList();
        });
    }


    // locateShopToXlsx(xlsxElement, change: MatSelectChange): void {
    //     xlsxElement.shopName2Save = change.value;
    //     // Find the selected shop name
    //     const selectedShop = this.listOfShops.find(shop => shop.id === change.value);
    //     if (selectedShop) {
    //         xlsxElement.tempShopName = selectedShop.shopName; // Temporarily update the shopName for UI
    //         console.log('Temporary shopName:', xlsxElement.tempShopName);
    //     }
    // }
    // 22222222222222222222  locateShopToXlsx(xlsxElement: any, change: MatSelectChange): void {
    //     console.log('Dropdown selection change detected:', change.value);

    //     // Update the shopName and tempShopName properties dynamically
    //     xlsxElement.tempShopName = change.value; // Assign selected shop ID temporarily
    //     const selectedShop = this.listOfShops.find(shop => shop.id === change.value);

    //     if (selectedShop) {
    //         xlsxElement.shopName = selectedShop.shopName; // Update the displayed shop name dynamically
    //         console.log('Updated ShopName:', xlsxElement.shopName);
    //     }

    //     // Log the updated element for debugging
    //     console.log('Updated element:', JSON.stringify(xlsxElement));

    //     // Trigger change detection to update the UI immediately
    //     this.cdr.detectChanges();
    // }


    // saveShopForXlsx(xlsxElement: any): void {
    //     if (!xlsxElement.shopName2Save) {
    //         return; // No shop selected to save
    //     }

    //     // Save the shop to the backend
    //     this.xlsxSOFilesSvc.locateShopId(xlsxElement.id, {
    //         shopId: xlsxElement.shopName2Save,
    //     }).subscribe(res => {
    //         // Finalize the shopName and refresh data
    //         xlsxElement.shopName = xlsxElement.tempShopName;
    //         xlsxElement.tempShopName = null; // Clear temporary selection
    //         this.getXlsxList(); // Optionally refresh the data
    //         console.log('Shop saved successfully:', xlsxElement.shopName);
    //     });
    // }  22222222222222222222222222222222222


    /* saveShopForXlsx(xlsxElement: any): void {
    //     if (!xlsxElement.shopName2Save) {
    //         return;
    //     }

    //     this.xlsxSOFilesSvc.locateShopId(xlsxElement.id, {
    //         shopId: xlsxElement.shopName2Save,
    //     }).subscribe(res => {
    //         this.getXlsxList();
    //     })
    // } */

    getShopsForCompany(companyId): any[] {
        if (!companyId) {
            return this.listOfShopsForLocate;
        }
        return this.listOfShopsForLocate.filter(el => Number(el.companyId) === Number(companyId));
    }

    clearFilters(): void {
        this.fromDate.reset();
        this.toDate.reset();
        this.shopIdByfilter.reset();
        this.fileNameFilter.reset();
        this.customerName.reset();
        this.searchShopIdDropDown.reset();
        this.searchLocateShopDropDown.reset();
        this.searchCustomerName.reset();
        this.previousPageShops = 0;
        this.fileMode.reset();
        this.pageParams.pageIndex = 0;
        this.getXlsxList(1, this.pageParams.pageSize);
    }
}
